'use client';

import { useEffect } from 'react';
import { handleUpdateTheme } from '@/utils/theme';
import React from 'react';

const defaultTheme = {
  primaryColor: '#33CCCC',
  secondaryColor: '#ECA400',
};

function publicCompanyStore(company) {
  const applyTheme = company?.theme || defaultTheme;
  if (applyTheme) {
    handleUpdateTheme(applyTheme);
  }
}

function publicNonProfitStore(nonProfit) {
  // Add functionality here
  const applyTheme = nonProfit?.company?.theme || defaultTheme;
  if (applyTheme) {
    handleUpdateTheme(applyTheme);
  }
}

const InitPublicStore = (props) => {
  const { company, nonProfit, user, original } = props;

  useEffect(() => {
    if (company) {
      publicCompanyStore(company);
    } else if (nonProfit) {
      publicNonProfitStore(nonProfit);
    } else if (original) {
      publicNonProfitStore();
    } else if (user) {
      const theme = user?.activeCommunity?.theme || defaultTheme;
      if (theme) {
        handleUpdateTheme(theme);
      }
    }
  }, [company, nonProfit, user]);

  return null;
};

export default InitPublicStore;
